import { Avatar } from '@change/ds-core-ui/Avatar';
import { Image } from '@change/ds-core-ui/Image';

import { useHydrationSafeImageFallback } from '#src/app/pages/socialStarter/shared/hooks';
import { normalizeHandle } from '#src/app/shared/utils/socialMedia';
import { firstInitial } from '#src/app/shared/utils/string';

export const SocialPostAvatar: React.FC<Props> = ({ name, handle, avatarUrl, size, qaId }) => {
	const fallbackInitial = firstInitial(name?.trim() || normalizeHandle(handle) || '');
	const src = avatarUrl || undefined;
	const initial = fallbackInitial || undefined;
	const fallback = <Avatar alt="" initial={initial} initialVariant={initial ? 'weak' : undefined} size={size} />;
	const { hasFailed, imageRef, showFallback } = useHydrationSafeImageFallback(src);

	return (
		<div
			aria-hidden="true"
			className="overflow-hidden rounded-full"
			data-qa={qaId}
			style={{ height: size, width: size }}
		>
			{src && !hasFailed ? (
				<Image
					ref={imageRef}
					src={src}
					alt=""
					aria-hidden="true"
					aspectRatio="1:1"
					className="h-full w-full object-cover"
					fallback={fallback}
					onError={showFallback}
				/>
			) : (
				fallback
			)}
		</div>
	);
};

type Props = {
	name: string | null | undefined;
	handle: string | null | undefined;
	avatarUrl: string | null | undefined;
	size: number;
	qaId: string;
};
